import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconHistory,
  IconHandStop,
  IconFilter,
  IconSearch,
  IconDownload,
  IconCalendar,
  IconTrash,
  IconDotsVertical,
  IconPlus,
  IconSettings,
  IconEdit,
  IconWritingSign,
  IconActivity,
  IconUsers,
  IconUsersGroup,
  IconPencilUp,
  IconClock,
  IconView360,
  IconEye,
  IconSend,
  IconEyeCheck,
  IconViewfinder,
  IconFileAnalytics,
  IconFileArrowRight,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Menu,
  rem,
  ScrollArea,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
  Collapse,
} from "@mantine/core";
import ProcessInstancesModel from "../../model/ProcessInstancesModel";
import { DatePickerInput } from "@mantine/dates";
import {
  getEcmClassSelect,
  getOrganizationsSelect,
  getPartnersSelect,
  getProcessDefSelect,
  getUsersSelect,
} from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import PopupStep from "../History/PopupStep";
import { modals } from "@mantine/modals";
import { FoldersModel } from "../../model/_baseId";
import { CreateProfile } from "./CreateProfile/CreateProfile";
import { BASE_API_MASTER, BASE_API_SIGN } from "../../_base/_const";
import {
  pageTable,
  repositorySign,
  styleTable,
} from "../../_base/_const/_constVar";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import DeleteTableView from "./CreateProfile/DeleteTableView/DeleteTableView";
import { IconSquareXFilled } from "@tabler/icons-react";
import { IconFile } from "@tabler/icons-react";
import { IconBrandRedux } from "@tabler/icons-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { downloadFileWithLoading } from "../../_base/helper/DownloadHelper";
import { useForm } from "@mantine/form";
import { EditProfile } from "./CreateProfile/EditProfile/EditProfile";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { FileReturnModel } from "../../model/FileReturnModel";
import { get } from "https";
import saveAs from "file-saver";
import HistoryProfile from "./CreateProfile/HistoryProfile/HistoryProfile";
import { PdfFileView } from "../Flow-step/PdfFileView";
import { IconEyeCode } from "@tabler/icons-react";
import { randomId } from "@mantine/hooks";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
import { IconMessageCircle } from "@tabler/icons-react";
import CommentModal from "./CommentModal/CommentModal";
import { useViewportSize } from "@mantine/hooks";

// Search history utility functions
const SEARCH_HISTORY_KEY = "folders_search_criteria_old";

interface SearchCriteria {
  keySearch: string;
  EmployeeId: string;
  PartnerId: string;
  DepartmentId: string;
  Status: string;
  DoctypeId: string;
}

const saveSearchCriteria = (criteria: SearchCriteria) => {
  try {
    const hasSearchCriteria = Object.values(criteria).some(
      (value) => value && value.toString().trim() !== ""
    );

    if (hasSearchCriteria) {
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(criteria));
    }
  } catch (error) {
    console.error("Error saving search criteria:", error);
  }
};

const getSearchCriteria = (): SearchCriteria | null => {
  try {
    const savedCriteria = localStorage.getItem(SEARCH_HISTORY_KEY);
    return savedCriteria ? JSON.parse(savedCriteria) : null;
  } catch (error) {
    console.error("Error reading search criteria:", error);
    return null;
  }
};

const clearSearchCriteria = () => {
  try {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  } catch (error) {
    console.error("Error clearing search criteria:", error);
  }
};

interface DocumentRecord {
  id: number | null;
  code: string | null;
  name: string | null;
  active: boolean | null;
  doctypeId: number | null;
  relateRecordsId: string | null;
  description: string | null;
  signedDocument: string | null;
  attachments: string | null;
  expirationDate: string | null;
  partnerId: number | null;
  departmentId: number | null;
  employeeId: number | null;
  createDate: string | null;
  createBy: number | null;
  lastUpdateDate: string | null;
  lastUpdateBy: number | null;
  startDate: string | null;
  signedDate: string | null;
  warningExpired: string | null;
  isSignature: boolean | null;
  stepCurrent: number | null;
  stepTotal: number | null;
  isSuccess: boolean | null;
  lastUpdateName: string | null;
  createName: string | null;
  doctypeName: string | null;
  isIgore: boolean | null;
  steupId: number | null;
  createByName: string | null;
  empByName: string | null;
  partnerName: string | null;
  employeName: string | null;
  departmentName: string | null;
  status: string | null;
  stepNumber: string | null;
}

const FoldersTableOld = () => {
  //#region  table
  //data and fetching state
  const [data, setData] = useState<DocumentRecord[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [searchParams] = useSearchParams();
  const [filterOpen, setFilterOpen] = useState(false);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [dataFetch, setDataFetch] = useState<SelectListItem[]>([]);
  const [listVendor, setListVendor] = useState<SelectListItem[]>([]);
  const [listDocType, setListDocType] = useState<SelectListItem[]>([]);
  const [listDocument, setListDocument] = useState<SelectListItem[]>([]);

  const [listEmployee, setListEmployee] = useState<SelectListItem[]>([]);
  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const navigate = useNavigate();
  const _span = { base: 4, md: 3, lg: 2 };
  const [search, setSearch] = useState({
    keySearch: "",
    EmployeeId: "",
    PartnerId: "",
    DepartmentId: "",
    customerId: "",
    startDate: "",
    endDate: "",
    codefund: "",
    accountfund: "",
    deartment: "",
    branch: "",
    type: "",
    workplace: "",
    creator: "",
    Type: 0,
    Status: "",
    DoctypeId: "",
  });

  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  // Function to handle search and save criteria
  const handleSearch = async () => {
    // const currentFilters = form.getValues();

    // // Save current search criteria to localStorage
    // saveSearchCriteria({
    //   keySearch: currentFilters.keySearch,
    //   EmployeeId: currentFilters.EmployeeId,
    //   PartnerId: currentFilters.PartnerId,
    //   DepartmentId: currentFilters.DepartmentId,
    //   Status: currentFilters.Status,
    //   DoctypeId: currentFilters.DoctypeId,
    // });

    // Perform search
    await fetchData();
  };

  // Function to clear search and history
  const handleClearSearch = () => {
    form.reset();
    clearSearchCriteria();
    fetchData();
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let _softing = "";
      if (sorting && sorting.length > 0) {
        let _q = sorting[0];
        if (_q) _softing = _q.id;
      }
      const queryParams = {
        Skip: pagination.pageIndex * pagination.pageSize,
        Take: pagination.pageSize,
        EmployeeId: form.getValues().EmployeeId,
        PartnerId: form.getValues().PartnerId,
        DepartmentId: form.getValues().DepartmentId,
        CustomerId: form.getValues().customerId,
        KeySearch:
          form.getValues().keySearch.toLowerCase() ||
          form.getValues().keySearch.toLowerCase(),
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
        Status: form.getValues().Status,
        DoctypeId: form.getValues().DoctypeId,
      };
      const baseUrl = "/api/v1/TblDocument/get-list-old";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue = value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<DocumentRecord[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const { width } = useViewportSize();
  const isMobile = width < 768;
  const isTablet = width < 1024;

  // Debug logging to check viewport size

  const columns = React.useMemo<MRT_ColumnDef<DocumentRecord>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Mã hồ sơ",
        size: isMobile ? 150 : 200,
        Cell: ({ renderedCellValue, row }) => {
          return (
            <Badge
              radius="sm"
              variant="dot"
              tt="capitalize"
              color="green"
              fw={700}
              size={isMobile ? "md" : "lg"}
            >
              {renderedCellValue}
            </Badge>
          );
        },
      },
      {
        accessorKey: "name",
        header: "Tên hồ sơ",
      },
      {
        accessorKey: "doctypeName",
        header: "Loại hồ sơ",
      },
      {
        accessorKey: "createByName",
        header: "Người tạo",
        size: 170,
      },
      {
        accessorKey: "employeName",
        header: "Nhân viên",
        size: 170,
      },

      {
        accessorKey: "departmentName",
        header: "Đơn vị",
      },
      {
        accessorKey: "partnerName",
        header: "Đối tác",
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "startDate",
        header: "Ngày bắt đầu",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "expirationDate",
        header: "Ngày hết hiệu lực",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: isMobile ? 80 : 50,
        enableSorting: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? "5px" : "10px",
            }}
          >
            <Button
              leftSection={<IconDownload size={16} />}
              onClick={() =>
                downloadFileWithLoading(
                  BASE_API_SIGN +
                    "/api/v1/signpage/get-files-old?id=" +
                    row.original.id,
                  row.original.name +
                    "-" +
                    new Date().toISOString().slice(0, 10) +
                    ".zip"
                )
              }
            >Tải xuống</Button>
          </Box>
        ),
      },
    ],
    [listVendor, dataFetch, listEmployee, listDocType, isMobile]
  );

  //API gọi danh sách nhân viên
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const responseDocType = await repositorySign.get<
          MessageResponse<SelectListItem[]>
        >("/api/v1/TblDocType/get-select");
        if (responseDocType && responseDocType.success) {
          setListDocType(responseDocType.data);
        }

        const _user = await getUsersSelect();
        if (_user) setListEmployee(_user);

        const responseDepartment = await repositorySign.get<
          MessageResponse<any>
        >("/api/v1/Department/get-select");
        if (responseDepartment && responseDepartment.success) {
          setDataFetch(responseDepartment.data);
        }

        const responseVendor = await repositorySign.get<
          MessageResponse<SelectListItem[]>
        >("/api/v1/TblVendor/get-select");
        if (responseVendor && responseVendor.success) {
          setListVendor(responseVendor.data);
        }

        const responseDocument = await repositorySign.get<
          MessageResponse<SelectListItem[]>
        >("/api/v1/TblDocument/get-select");
        if (responseDocument && responseDocument.success) {
          setListDocument(responseDocument.data);
        }

        // Load search from URL params first
        const urlKeySearch = searchParams.get("code") ?? "";
        if (urlKeySearch) {
          form.setFieldValue("keySearch", urlKeySearch);
        }
        
        // Always set initialized to true after loading data
        setIsInitialized(true);
      } catch (error) {
        console.error("lỗi:", error);
        setIsInitialized(true);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    // Only call fetchData after initialization is complete
    if (isInitialized) {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize, sorting, isInitialized]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (220 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable<DocumentRecord>({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    localization: _localization,
    enableRowSelection: true,
    enableTopToolbar: false,
    getRowId: (row) => row?.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnVisibility: {
        id: false,
        // Hide less important columns on mobile
        ...(isMobile && {
          departmentName: false,
          partnerName: false,
          startDate: false,
          expirationDate: false,
          stepNumber: false,
        }),
      },
      density: isMobile ? "md" : "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
      columnPinning: isMobile
        ? {}
        : {
            left: ["mrt-row-select", "code"],
            right: ["action"],
          },
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: !isMobile,
    mantineTableProps: {
      striped: false,
    },
  });

  //#endregion
  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: isMobile ? "8px" : "10px",
        }}
        ref={headerRef}
      >
        <Flex
          justify="space-between"
          align={isMobile ? "flex-start" : "center"}
          direction={isMobile ? "column" : "row"}
          gap={isMobile ? "sm" : "md"}
        >
          <BreadcrumbLayout1 />
          <Flex
            gap={isMobile ? "xs" : "md"}
            align="center"
            direction={isMobile ? "column" : "row"}
            wrap="wrap"
            w={isMobile ? "100%" : "auto"}
          >
            {isMobile && (
              <Button
                leftSection={<IconFilter size={14} />}
                color="orange"
                variant={filterOpen ? "filled" : "outline"}
                onClick={() => setFilterOpen(!filterOpen)}
                size="sm"
                fullWidth
              >
                {filterOpen ? "Ẩn bộ lọc" : "Bộ lọc"}
              </Button>
            )}
          </Flex>
        </Flex>

        {isMobile ? (
          // Mobile: Collapsible filter
          <Collapse in={filterOpen}>
            <form
              style={{
                marginTop: "12px",
                paddingTop: "12px",
                borderTop: "1px solid #e9ecef",
              }}
            >
              <Grid gutter="xs">
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <TextInput
                    label="Từ khóa"
                    leftSection={<IconSearch color="#15aabf" size={16} />}
                    placeholder="Nhập từ khóa"
                    key={form.key(`keySearch`)}
                    {...form.getInputProps("keySearch")}
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    label="Nhân viên"
                    leftSection={<IconUsers color="#15aabf" size={16} />}
                    placeholder="Chọn nhân viên"
                    data={listEmployee.map((employee) => ({
                      value: employee.value ?? "",
                      label: employee.text,
                    }))}
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    key={form.key(`EmployeeId`)}
                    {...form.getInputProps("EmployeeId")}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    label="Đối tác"
                    key={form.key(`PartnerId`)}
                    leftSection={<IconUsersGroup color="#15aabf" size={16} />}
                    placeholder="Chọn đối tác"
                    data={listVendor.map((employee) => ({
                      value: employee.value,
                      label: employee.text,
                    }))}
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    {...form.getInputProps("PartnerId")}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    key={form.key(`DoctypeId`)}
                    label="Hồ sơ"
                    leftSection={<IconFile color="#15aabf" size={16} />}
                    placeholder="Chọn hồ sơ"
                    data={listDocType.map((employee) => ({
                      value: employee.value,
                      label: employee.text,
                    }))}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    {...form.getInputProps("DoctypeId")}
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    label="Đơn vị"
                    leftSection={<IconPencilUp color="#15aabf" size={16} />}
                    placeholder="Chọn đơn vị"
                    data={dataFetch.map((employee) => ({
                      value: employee.value,
                      label: employee.text,
                    }))}
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    key={form.key(`DepartmentId`)}
                    {...form.getInputProps("DepartmentId")}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    size="sm"
                  />
                </Grid.Col>

                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Flex gap="xs" style={{ paddingTop: "25px" }}>
                    <Button
                      leftSection={<IconSearch size={14} />}
                      color="blue"
                      variant="outline"
                      onClick={handleSearch}
                      size="sm"
                      style={{ flex: 1 }}
                    >
                      Tìm kiếm
                    </Button>
                  </Flex>
                </Grid.Col>
              </Grid>
            </form>
          </Collapse>
        ) : (
          // Desktop: Original filter layout
          <form style={{ marginTop: "16px" }}>
            <Grid>
              <Grid.Col span={_span}>
                <TextInput
                  label="Từ khóa"
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  label="Nhân viên"
                  leftSection={<IconUsers color="#15aabf" />}
                  placeholder="Chọn nhân viên trình ký"
                  data={listEmployee.map((employee) => ({
                    value: employee.value ?? "",
                    label: employee.text,
                  }))}
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  key={form.key(`EmployeeId`)}
                  {...form.getInputProps("EmployeeId")}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  label="Đối tác"
                  key={form.key(`PartnerId`)}
                  leftSection={<IconUsersGroup color="#15aabf" />}
                  placeholder="Chọn đối tác"
                  data={listVendor.map((employee) => ({
                    value: employee.value,
                    label: employee.text,
                  }))}
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  {...form.getInputProps("PartnerId")}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  key={form.key(`DoctypeId`)}
                  label="Hồ sơ"
                  leftSection={<IconFile color="#15aabf" />}
                  placeholder="Chọn hồ sơ"
                  data={listDocType.map((employee) => ({
                    value: employee.value,
                    label: employee.text,
                  }))}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  {...form.getInputProps("DoctypeId")}
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  label="Đơn vị"
                  leftSection={<IconPencilUp color="#15aabf" />}
                  placeholder="Chọn đơn vị trình ký"
                  data={dataFetch.map((employee) => ({
                    value: employee.value,
                    label: employee.text,
                  }))}
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  key={form.key(`DepartmentId`)}
                  {...form.getInputProps("DepartmentId")}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                />
              </Grid.Col>

              <Grid.Col span={_span}>
                <div style={{ paddingTop: "25px" }}>
                  <Button
                    leftSection={<IconSearch size={14} />}
                    color="blue"
                    variant="outline"
                    onClick={handleSearch}
                  >
                    Tìm kiếm
                  </Button>
                </div>
              </Grid.Col>
            </Grid>
          </form>
        )}
      </div>
      <div style={{ overflowX: isMobile ? "auto" : "unset" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default FoldersTableOld;
